import React from 'react';
import styled from 'styled-components';
import { Typography } from 'src/typography';
import Imgix from 'shared/components/imgix';
import { LockIconSimple } from 'src/assets/lock-icon-simple';
import { mediaQueries } from 'shared/styles';

type CollectionsHeaderProps = {
  title: string;
  description?: string;
  image?: string;
  customCategory?: boolean;
  isExclusive?: boolean;
  cardBadgeColor?: string;
};

const imgixParams = {
  h: 296,
  w: 1940,
  fit: 'crop',
};

export const CollectionsHeader = ({
  title,
  description,
  image,
  customCategory,
  isExclusive,
  cardBadgeColor,
}: CollectionsHeaderProps): JSX.Element => (
  <>
    {!customCategory && (
      <Wrapper>
        <Heading tag='h1' size='medium'>
          {isExclusive && (
            <ExclusiveLabel $color={cardBadgeColor}>
              <LockIconSimple color='currentColor' />
              <span>Exclusive Collection</span>
            </ExclusiveLabel>
          )}
          {title}
        </Heading>

        {description && <Description size='large'>{description}</Description>}

        {image && (
          <ImageWrapper>
            <Image src={image} alt={title} imgixParams={imgixParams} disableSrcSet />
          </ImageWrapper>
        )}
      </Wrapper>
    )}
  </>
);

const Wrapper = styled.div`
  margin: 0 0 24px;
  width: 100%;
`;

const Heading = styled(Typography.Heading)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;

  @media ${mediaQueries.medium} {
    flex-direction: row-reverse;
    justify-content: flex-end;
    align-items: center;
  }
`;

const ExclusiveLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 16px;
  font-weight: 600;
  color: ${({ $color }) => $color};
  svg {
    width: 20px;
    height: 20px;
  }
`;

const Description = styled(Typography.Body)`
  color: #4b5257;
  margin-top: 8px;
`;

const ImageWrapper = styled.div`
  border-radius: ${({ theme }) => theme.customized.radius.lg};
  height: 148px;
  margin: 16px 0 0;
  max-width: 970px;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const Image = styled(Imgix)`
  display: block;
  height: 100%;
  left: 50%;
  max-width: none;
  position: absolute;
  top: 0;
  transform: translateX(-50%);
`;
